import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import {
  Facebook,
  Twitter,
  WhatsApp,
  Viber,
  Email,
  Telegram
} from 'src/modules/layout/Sidebar/shared/components/SocServices'
import { getCurrentAd } from 'src/modules/ads/detail/selectors'

const Share = ({ router, ad }) => {
  let link = ad && ad.link ? ad.link : 'https://oglasi.me'

  return <div className='oglasi-share'>
    <Facebook adLink={link} />
    <Twitter adLink={link} />
    <WhatsApp adLink={link} />
    <Viber adLink={link} />
    <Email adLink={link} />
    <Telegram adLink={link} />
  </div>
}

Share.propTypes = {
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired
  }),
  ad: PropTypes.shape({
    link: PropTypes.string.isRequired
  })
}

export default compose(connect(state => ({ ad: getCurrentAd(state) })), withRouter)(Share)
